const config = {
  API_URL: process.env.REACT_APP_API,
  LOGO_URL: process.env.PUBLIC_URL + '/logo192.png',
  VERSION: process.env.REACT_APP_VERSION,
  ENV: process.env.NODE_ENV,
};

export default config;
